'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceGraphicEq = function DeviceGraphicEq(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
  );
};
DeviceGraphicEq = (0, _pure2.default)(DeviceGraphicEq);
DeviceGraphicEq.displayName = 'DeviceGraphicEq';

exports.default = DeviceGraphicEq;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/graphic-eq.js
 ** module id = 1373
 ** module chunks = 0
 **/